import type { Filters } from "@superbright/indexeddb-orm";
import { useInResiStore } from "@superbright/indexeddb-orm";

export const filterActions = {
  /**
   * Merge a partial filter object into committed filters AND tempFilters.
   * Hydration (URL/bootstrap) and Apply/Clear all need the pills UI (which
   * prefers temp) to see the same values as the committed store.
   */
  set: (filters: Partial<Filters>): void => {
    useInResiStore.setState((state) => ({
      filters: { ...state.filters, ...filters },
      tempFilters: { ...state.tempFilters, ...filters },
    }));
  },
};
